import * as utils from '../utils';
export function getBody(node) {
    return utils.getValueOrUndefined(node.body);
}
export function getBodyOrThrow(node) {
    return utils.throwIfNullOrUndefined(getBody(node), 'body');
}
export function hasBody(node) {
    return getBody(node) !== undefined;
}

//# sourceMappingURL=body.js.map
